import logger from './logger'

type UType = string | number | readonly [any, ...unknown[]]

export async function fetcher<T, U extends UType>(url: U): Promise<T> {
  let response: Response
  try {
    response = await fetch(String(url))
  } catch (err) {
    // Catch low-level network failures (dropped connection, navigation away,
    // ad-blocker blocking the request, etc.) so they're reported as handled
    // exceptions rather than unhandled promise rejections.
    const networkError = new TypeError(err instanceof Error ? err.message : 'Failed to fetch')
    networkError.name = 'NetworkError'
    logger.warn(
      { err, context: 'com.gratia.app.util.fetcher', url: String(url) },
      'Network error in fetcher',
    )
    throw networkError
  }
  if (!response.ok) {
    const json = await response.json()
    const error = new Error(json.error || response.statusText)
    logger.error({ err: error, context: 'com.gratia.app.util.fetcher' }, `Error from fetcher: ${error.message}`)
    throw error
  }
  return response.json()
}
